"use client";

import { useEffect, useState } from "react";

import {
  fetchPlaidGateRemoteConfig,
  PLAID_FREE_TRIAL_DAYS_DEFAULT,
  PLAID_GATE_MODE_DEFAULT,
  type PlaidGateMode,
  type PlaidGateRemoteConfig,
} from "./plaidGateRemoteConfig";

/**
 * Firebase RC：`plaid_gate_mode` / `plaid_free_trial_days`（只读预留；本期到期 UI 以 gate-state 为准）。
 */
export function usePlaidGateRemoteConfig(): PlaidGateRemoteConfig {
  const [config, setConfig] = useState<PlaidGateRemoteConfig>({
    mode: PLAID_GATE_MODE_DEFAULT,
    freeTrialDays: PLAID_FREE_TRIAL_DAYS_DEFAULT,
  });

  useEffect(() => {
    let cancelled = false;
    void fetchPlaidGateRemoteConfig().then((next) => {
      if (!cancelled) {
        setConfig(next);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}

export type { PlaidGateMode, PlaidGateRemoteConfig };
